/**
 * LinkedIn Integration Module (Stories 10.1, 10.2)
 *
 * Barrel export for LinkedIn OAuth, scopes, discovery, token refresh, and adapters.
 */

import { registerAdapter } from "../registry";
import { linkedinPagesAdapter } from "./linkedin-pages";
import { linkedinAdsAdapter } from "./linkedin-ads";

// Register LinkedIn Pages adapter (Story 10.2)
registerAdapter("linkedin-pages", linkedinPagesAdapter);

// Register LinkedIn Ads adapter (Story 10.3)
registerAdapter("linkedin-ads", linkedinAdsAdapter);

// Re-export all LinkedIn modules
export {
  buildLinkedInAuthUrl,
  exchangeLinkedInCode,
  refreshLinkedInToken,
  parseLinkedInCallbackError,
  type LinkedInAuthUrlOptions,
  type LinkedInTokenResponse,
  type LinkedInCallbackError,
} from "./oauth";

export {
  LINKEDIN_API_VERSION,
  LINKEDIN_PLATFORM_VALUES,
  LINKEDIN_INTEGRATION_SCOPES,
  ALL_LINKEDIN_SCOPES,
  LINKEDIN_OAUTH_PLATFORMS,
  getEnabledLinkedInPlatforms,
  detectLinkedInScopeReduction,
  type LinkedInPlatform,
  type LinkedInScopeConfig,
} from "./scopes";

export {
  discoverLinkedInAccounts,
  discoverLinkedInOrganizations,
  discoverLinkedInAdAccounts,
  parseOrganizationUrn,
  type LinkedInDiscoveryResult,
  type LinkedInDiscoveryOptions,
  type LinkedInFamilyDiscoveryOptions,
  type LinkedInOrganizationsDiscoveryResult,
  type LinkedInAdAccountsDiscoveryResult,
  type DiscoveredOrganization,
  type DiscoveredAdAccount,
} from "./discovery";

export {
  refreshLinkedInAccessToken,
  type LinkedInRefreshResult,
} from "./token-refresh";

export {
  linkedinPagesAdapter,
  LINKEDIN_PAGES_METRICS,
  LINKEDIN_PAGES_DIMENSIONS,
} from "./linkedin-pages";

export { parseLinkedInError, type ParsedLinkedInError } from "./errors";

export {
  linkedinAdsAdapter,
  LINKEDIN_ADS_METRICS,
  LINKEDIN_ADS_DIMENSIONS,
} from "./linkedin-ads";
